import { render, staticRenderFns } from "./InvestPostItem.vue?vue&type=template&id=4b37bfc8&scoped=true&"
import script from "./InvestPostItem.vue?vue&type=script&lang=js&"
export * from "./InvestPostItem.vue?vue&type=script&lang=js&"
import style0 from "./InvestPostItem.vue?vue&type=style&index=0&id=4b37bfc8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b37bfc8",
  null
  
)

export default component.exports